var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTakePhoto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "layer",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 450",
    style: {
      enableBackground: "new 0 0 480 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#945850"
    },
    d: "M85.409,266.882c-0.318,5.231,0.412,10.438,5.995,12.698l0,0      c5.583,2.26,13.905,0.718,14.223-4.513c0.728-11.995,7.998-29.272,14.57-38.081c3.733-5.005-1.049-10.779-6.633-13.039l0,0      c-2.647-1.072-6.457-1.187-8.888-0.663c-16.219,3.496-22.037,5.69-22.037,5.69C75.127,239.59,86.188,254.05,85.409,266.882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#945850"
    },
    d: "M112.761,245.859l-47.933,6.089c12.164-25.028,13.563-26.147,37.332-28.943      c1.386-0.163,5.701-0.377,9.307,1.083c5.583,2.26,10.366,8.035,6.633,13.039C116.323,239.508,114.496,242.511,112.761,245.859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#662F2B"
    },
    d: "M113.454,222.982c0.338,0.032,0.815,2.434,0.917,3.302c-1.754-0.937-4.731-2.301-4.731-2.301      l-1.179-2.178L113.454,222.982z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7C433D"
    },
    d: "M63.736,271.636c-0.318,5.231,0.412,10.438,5.996,12.698l0,0      c5.583,2.26,13.905,0.718,14.223-4.513c0.729-11.995,7.999-29.272,14.57-38.081c3.733-5.005-1.05-10.779-6.633-13.039l0,0      c-5.583-2.26-11.137,0.154-14.223,4.513C70.156,243.831,64.516,258.803,63.736,271.636z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#140B06"
    },
    points: "50.659,365.668 36.55,365.668 35.767,357.459 50.659,357.459       "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B2416"
    },
    d: "M38.882,361.41c0,4.094,3.883,6.046,3.883,6.046c0,4.045-4.243,4.174-4.243,11.356l0,0         c-0.083,4.786-0.852,7.598-4.816,7.598h-7.541v-31.14l3.655,0h6.842h3.655C41.348,355.27,38.882,356.878,38.882,361.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#28160D"
    },
    d: "M31.127,355.27v22.25c0,1.713,1.388,3.101,3.101,3.101h4.215         c-0.27,3.676-1.305,5.789-4.738,5.789h-7.541v-31.14l3.655,0H31.127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6FBBDD"
    },
    d: "M25.63,353.562h1.59c1.145,0,2.073,0.928,2.073,2.073v30.409c0,1.145-0.928,2.074-2.073,2.074         h-1.59V353.562z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#668C44"
    },
    d: "M146.059,240.992c46.741,28.887,48.416-35.833,48.416-35.833l9.956-0.2l0.42,2.671        c-1.249,13.865-10.102,75.536-67.494,43.647C128.426,246.316,138.478,236.307,146.059,240.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#719B51"
    },
    d: "M146.059,240.992c46.741,28.887,48.416-35.833,48.416-35.833l9.893-0.199l0.34,2.162        l-4.285,0.333c0,0-1.595,73.775-66.463,37.945C134.827,241.296,140.991,237.86,146.059,240.992z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90BA6A"
    },
    d: "M143.365,241.279c-3.704-2.867-8.641-1.589-11.164,1.097c1.456-3.955,7.921-6.745,12.5-3.201         c20.961,16.223,34.004,8.893,41.846-2.738C178.883,249.224,165.566,258.46,143.365,241.279z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#719B51"
    },
    d: "M127.27,227.704c-11.642-0.624-46.197,8.374-44.342,74.743c26.29,0,27.836,0,27.836,0        s-4.949-29.773,19.799-40.008C149.116,254.686,143.726,228.587,127.27,227.704z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4977A"
    },
    d: "M188.45,232.529c5.333-12.766,4.501-27.388,4.501-27.388l12.229,2.415        c0,0-0.125,15.759-8.531,31.511C193.746,237.1,190.994,234.923,188.45,232.529z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90BA6A"
    },
    d: "M129.13,229.492c-10.761-0.598-41.44,7.345-46.197,63.024         c1.694-57.343,33.304-65.403,44.337-64.811c4.742,0.254,8.562,2.604,11.158,6.004         C136.049,231.291,132.904,229.701,129.13,229.492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90BA6A"
    },
    d: "M109.917,302.447c-0.01-1.97,0.088-4.492,0.458-7.312c-0.1,4.361,0.39,7.312,0.39,7.312         S110.645,302.447,109.917,302.447z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#668C44"
    },
    d: "M127.579,256.703c9.277,0,14.667-5.428,14.667-13.923c1.033,7.461-2.347,15.759-11.682,19.66        c-24.748,10.234-19.799,40.008-19.799,40.008s-4.889,0-17.765,0c0,0-2.016-35.355,12.096-55.824        C108.292,241.986,119.9,256.703,127.579,256.703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M119.732,237.558c1.618,5.124,6.987,9.278,11.993,9.278c5.005,0,7.751-4.154,6.133-9.278        c-1.618-5.124-6.987-9.278-11.993-9.278C120.86,228.28,118.114,232.434,119.732,237.558z M126.054,228.682        c4.203,0,8.712,3.482,10.07,7.777c1.359,4.295-0.947,7.777-5.15,7.777s-8.712-3.482-10.07-7.777        C119.545,232.164,121.851,228.682,126.054,228.682z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.934,
    y: 218.141,
    transform: "matrix(0.4399 -0.898 0.898 0.4399 -127.4439 244.3447)",
    style: {
      fill: "#E5876A"
    },
    width: 24.469,
    height: 12.405
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M129.134,215.663c0,9.516,7.715,17.231,17.231,17.231h5.078          c9.516,0,17.231-7.715,17.231-17.231v-27.449c0-9.516-7.714-17.231-17.231-17.231h-5.078          c-9.516,0-17.231,7.715-17.231,17.231V215.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5876A"
    },
    d: "M136.768,173.903c-0.088,0.62-0.134,1.293-0.134,2.024v0.589          c-1.56,2.591-2.459,5.626-2.459,8.871v27.448c0,9.516,7.715,17.231,17.231,17.231h5.079c2.027,0,3.971-0.352,5.777-0.995          c-2.957,2.39-6.72,3.823-10.818,3.823h-5.079c-9.516,0-17.231-6.528-17.231-16.045v-28.635          C129.134,182.251,132.164,176.996,136.768,173.903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M155.449,220.57h3.327c3.716,0,7.004-1.761,9.06-4.471c-0.664,5.334-4.586,9.433-9.332,9.433          h-2.782c-4.746,0-8.668-4.099-9.332-9.433C148.445,218.809,151.733,220.57,155.449,220.57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5876A"
    },
    d: "M161.749,210.363c-0.051,1.659-1.217,2.986-2.648,2.986h-0.781          c-1.432,0-2.597-1.327-2.648-2.986H161.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34313A"
    },
    d: "M169.4,187.792c-8.222,0-22.612,0-26.481,0s-6.53-3.869-6.53-3.869s2.781,5.441,2.781,7.497          c0,5.683,0.586,15.244-4.086,15.244c-2.902,0,1.426-9.078-3.048-9.078c-1.935,0-2.781,1.451-2.781,5.079          c0,3.628,0,9.432,0,13.906c-3.628-3.628-16.687-29.988-0.847-40.145c3.265-16.324,26.602-21.161,38.331-9.311          c6.524,6.591,10.736,8.719,10.736,8.719S180.283,187.792,169.4,187.792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34313A"
    },
    d: "M144.776,197.596c0,0.74,0.6,1.341,1.34,1.341h9.024c0.74,0,1.34-0.6,1.34-1.341l0,0          c0-0.74-0.6-1.341-1.34-1.341h-9.024C145.376,196.255,144.776,196.856,144.776,197.596L144.776,197.596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34313A"
    },
    d: "M160.372,197.596c0,0.74,0.6,1.341,1.341,1.341h6.441c0.74,0,1.34-0.6,1.34-1.341l0,0          c0-0.74-0.6-1.341-1.34-1.341h-6.441C160.973,196.255,160.372,196.856,160.372,197.596L160.372,197.596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34313A"
    },
    d: "M147.094,202.372c0,0.28,0.227,0.507,0.507,0.507h5.949c0.28,0,0.507-0.227,0.507-0.507l0,0          c0-0.28-0.227-0.507-0.507-0.507h-5.949C147.321,201.865,147.094,202.092,147.094,202.372L147.094,202.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34313A"
    },
    d: "M163.887,202.863c0,0.681,0.552,1.234,1.234,1.234c0.681,0,1.234-0.552,1.234-1.234          c0-0.681-0.552-1.234-1.234-1.234C164.44,201.629,163.887,202.181,163.887,202.863z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27242D"
    },
    d: "M140.214,179.791c3.869,0,18.259,0,26.481,0c5.758,0,7.683-2.877,8.22-5.586          c1.642,1.165,2.561,1.629,2.561,1.629s2.807,11.958-8.076,11.958c-8.222,0-22.612,0-26.481,0s-6.53-3.869-6.53-3.869          S136.345,179.791,140.214,179.791z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27242D"
    },
    d: "M129.255,208.158c0,2.798,0,5.826,0,8.412c-2.21-2.21-7.921-12.858-8.464-23.139          C122.152,199.34,125.212,204.841,129.255,208.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27242D"
    },
    d: "M134.093,202.862L134.093,202.862c4.672,0,2.712-6.682,2.712-11.566          c0-1.767-0.417-7.373-0.417-7.373s2.781,5.441,2.781,7.497c0,5.683,0.586,15.244-4.086,15.244          C133.791,206.664,133.934,204.86,134.093,202.862z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M128.2,207.955c0,2.003,1.624,3.627,3.627,3.627l0,0c2.003,0,3.627-1.624,3.627-3.627v-7.5         c0-2.003-1.624-3.627-3.627-3.627l0,0c-2.003,0-3.627,1.624-3.627,3.627V207.955z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M194.943,208.024c0.395,2.509,3.002,4.183,5.823,3.739l0,0         c2.821-0.444,4.788-2.838,4.393-5.347l-1.504-9.555c-0.395-2.509-2.671-2.077-5.492-1.633l0,0         c-2.821,0.444-5.12,0.732-4.725,3.241L194.943,208.024z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9D9D9E"
    },
    d: "M163.434,203.761c-0.358,1.398-0.155,2.558,0.488,2.457l21.973-3.458            c0.643-0.101,0.479-1.268-0.291-2.488l-7.708-12.217c-0.172-0.273-0.53-0.45-0.806-0.407l-9.432,1.485            c-0.276,0.043-0.562,0.322-0.642,0.635L163.434,203.761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27242D"
    },
    d: "M157.163,217.204c0.141,0.895,0.98,1.506,1.875,1.365l30.596-4.815            c0.895-0.141,1.506-0.98,1.365-1.875l-3.018-19.177c-0.141-0.895-0.98-1.506-1.875-1.365l-30.596,4.815            c-0.895,0.141-1.506,0.98-1.365,1.875L157.163,217.204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9D9D9E"
    },
    d: "M165.501,214.109l0.538,3.417l-6.992,1.1c-0.895,0.141-1.734-0.47-1.875-1.365l-0.29-1.84            l8.62-1.357C165.502,214.08,165.498,214.094,165.501,214.109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9D9D9E"
    },
    d: "M155.506,196.129l8.044-1.266l0.59,3.746l-9.664,1.521l-0.335-2.126            C154,197.109,154.611,196.27,155.506,196.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34313A"
    },
    d: "M163.628,216.187c0.141,0.895,0.98,1.506,1.875,1.365l30.596-4.815            c0.895-0.141,1.506-0.98,1.365-1.875l-3.018-19.177c-0.141-0.895-0.98-1.506-1.875-1.365l-30.596,4.815            c-0.895,0.141-1.506,0.98-1.365,1.875L163.628,216.187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6B6B7"
    },
    d: "M160.937,199.092l-0.331-2.106c-0.141-0.895,0.47-1.734,1.365-1.875l30.596-4.815            c0.895-0.141,1.734,0.47,1.875,1.365l0.331,2.106L160.937,199.092z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6B6B7"
    },
    d: "M197.182,209.075l0.29,1.845c0.141,0.895-0.47,1.734-1.365,1.875l-30.596,4.815            c-0.895,0.141-1.734-0.47-1.875-1.365l-0.29-1.845L197.182,209.075z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6B6B7"
    },
    d: "M169.158,196.821l1.971-7.702c0.08-0.313,0.366-0.591,0.642-0.635l9.432-1.485            c0.276-0.043,0.633,0.134,0.806,0.407l4.242,6.724L169.158,196.821z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C1E1E"
    },
    d: "M185.894,190.381c0.084,0.533,0.584,0.897,1.117,0.814l3.442-0.542            c0.533-0.084,0.897-0.584,0.814-1.117l0,0c-0.084-0.533-0.584-0.898-1.117-0.814l-3.442,0.542            C186.174,189.347,185.81,189.848,185.894,190.381L185.894,190.381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A83636"
    },
    d: "M187.936,190.059c0.084,0.533,0.393,0.928,0.691,0.881l1.92-0.302            c0.298-0.047,0.471-0.517,0.387-1.05l0,0c-0.084-0.533-0.393-0.928-0.691-0.881l-1.92,0.302            C188.025,189.056,187.852,189.526,187.936,190.059L187.936,190.059z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#720F0F"
    },
    d: "M186.708,189.263l0.162-0.025c-0.279,0.231-0.435,0.626-0.369,1.048            c0.066,0.421,0.336,0.749,0.673,0.883l-0.162,0.026c-0.533,0.084-1.034-0.28-1.117-0.814            C185.81,189.848,186.174,189.347,186.708,189.263z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3D8DE"
    },
    d: "M172.969,192.565c0.051,0.326,0.451,0.534,0.892,0.465l6.692-1.053           c0.441-0.069,0.758-0.39,0.706-0.716l-0.433-2.751c-0.051-0.326-0.451-0.534-0.892-0.465l-6.692,1.053           c-0.441,0.069-0.758,0.39-0.706,0.716L172.969,192.565z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70BDC1"
    },
    d: "M181.262,191.37l-3.992-2.906l2.665-0.419c0.441-0.069,0.841,0.139,0.892,0.465l0.433,2.752          C181.266,191.297,181.265,191.334,181.262,191.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70BDC1"
    },
    d: "M172.578,190.081l-0.042-0.267c-0.051-0.326,0.265-0.647,0.706-0.716l0.374-0.059          l4.551,3.313l-2.031,0.32C174.951,191.808,173.764,190.944,172.578,190.081z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M184.341,187.569c0.182,1.154,1.264,1.942,2.419,1.761l5.595-0.88         c1.154-0.182,1.942-1.264,1.761-2.418l0,0c-0.182-1.154-1.264-1.942-2.418-1.761l-5.595,0.881         C184.948,185.332,184.16,186.415,184.341,187.569L184.341,187.569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M199.674,197.348c2.129-0.335,3.027-2.113,2.162-3.686l-2.724-4.954         c-0.376-0.684-1.587-1.037-2.741-0.855l0,0c-1.154,0.182-2.006,0.859-1.892,1.585l0.827,5.253         C195.568,196.358,197.545,197.683,199.674,197.348L199.674,197.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M190.328,185.204c-0.675,0.928-0.508,2.166,0.371,2.806l4.571,3.328         c1.012,0.736,2.559,0.626,3.463-0.294l0,0c0.939-0.956,0.794-2.374-0.331-3.117l-5.055-3.339         C192.379,183.949,191.027,184.244,190.328,185.204L190.328,185.204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M195.074,191.802c-0.688,0.944-0.479,2.268,0.465,2.955l4.579,3.333         c0.945,0.688,2.268,0.479,2.955-0.465l0,0c0.688-0.945,0.479-2.268-0.465-2.955l-4.579-3.333         C197.085,190.649,195.762,190.857,195.074,191.802L195.074,191.802z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4977A"
    },
    d: "M197.197,195.509l1.316,8.36c0.395,2.509,3.002,4.183,5.823,3.739         c0.328-0.052,0.643-0.132,0.945-0.233c-0.107,2.181-1.865,4.854-4.367,5.247c-2.821,0.444-5.496-1.975-5.891-4.484         l-1.504-9.555C193.174,196.393,194.881,195.896,197.197,195.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M197.873,191.361c-0.944-0.688-2.267-0.479-2.955,0.465l-3.333,4.578         c-0.688,0.945-0.479,2.268,0.465,2.955l0,0c0.944,0.688,2.267,0.48,2.955-0.465l3.333-4.578         C199.026,193.372,198.818,192.049,197.873,191.361L197.873,191.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M195.806,196.453c-0.688,0.944-0.479,2.268,0.465,2.955l4.579,3.333         c0.945,0.688,2.268,0.479,2.955-0.465l0,0c0.688-0.945,0.479-2.268-0.465-2.955l-4.579-3.333         C197.817,195.3,196.494,195.508,195.806,196.453L195.806,196.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M198.605,196.012c-0.944-0.688-2.267-0.479-2.955,0.465l-3.333,4.578         c-0.688,0.944-0.479,2.268,0.465,2.955l0,0c0.944,0.688,2.267,0.48,2.955-0.465l3.333-4.578         C199.758,198.023,199.55,196.7,198.605,196.012L198.605,196.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M196.538,201.104c-0.688,0.945-0.479,2.268,0.465,2.955l4.579,3.333         c0.945,0.688,2.268,0.479,2.955-0.465l0,0c0.688-0.945,0.479-2.268-0.465-2.955l-4.579-3.333         C198.549,199.951,197.226,200.159,196.538,201.104L196.538,201.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M199.337,200.663c-0.944-0.688-2.267-0.479-2.955,0.465l-3.333,4.578         c-0.688,0.944-0.479,2.268,0.465,2.955l0,0c0.944,0.688,2.267,0.48,2.955-0.465l3.333-4.579         C200.49,202.674,200.282,201.351,199.337,200.663L199.337,200.663z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27242D"
    },
    d: "M190.232,202.093c-0.958-6.085-0.12-11.281-6.198-10.407c-0.05,0.007-6.608,1.039-6.658,1.047         c-6.135,0.966-10.325,6.721-9.36,12.856c0.965,6.135,6.721,10.325,12.856,9.36c0.05-0.008,6.881-1.083,6.931-1.092         C193.856,212.823,191.19,208.178,190.232,202.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9D9D9E"
    },
    d: "M179.725,192.364c0.019-0.003,0.949-0.149,2.108-0.332         c-6.134,0.966-10.323,6.722-9.358,12.856c0.965,6.134,6.72,10.324,12.854,9.36c-1.166,0.184-2.09,0.329-2.108,0.332         c-6.135,0.965-11.891-3.225-12.856-9.36C169.399,199.085,173.59,193.329,179.725,192.364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M170.092,207.17c1.025-0.689,2.414-0.417,3.103,0.608l3.023,4.496l4.16,2.382         c0.167,0.096,0.312,0.213,0.443,0.342l5.956-0.937l2.949-2.819l-0.723-2.075c-0.313-0.8,0.023-1.687,0.749-2.099         l-0.991-2.124c-0.431-0.838-0.1-1.866,0.737-2.297c0.838-0.43,1.866-0.1,2.297,0.737l1.12,2.4         c0.083,0.162,0.13,0.331,0.158,0.502c0.069,0.144,0.125,0.297,0.151,0.462l0.583,3.707c0.299,0.644,0.181,1.431-0.361,1.949         l-0.125,0.119l0.144,2.637c0.232,0.671,0.035,1.442-0.557,1.902l-1.008,0.784l-0.478,2.917         c-0.004,0.023-0.013,0.043-0.018,0.066c-0.167,1.307-2.11,5.551-3.81,6.467c0,0-4.396,1.418-8.035,0.935         c-1.316-0.175-4.763-1.758-4.982-4.824l0.002-3.761l-1.693-4.453c-0.138-0.123-0.268-0.258-0.376-0.418l-3.027-4.502         C168.795,209.248,169.067,207.859,170.092,207.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E5"
    },
    d: "M197.02,201.025c-0.965-6.135-6.721-10.325-12.856-9.36c-0.092,0.014-0.184,0.03-0.275,0.047         c-5.984,1.092-10.035,6.767-9.084,12.809c0.965,6.135,6.721,10.325,12.856,9.36S197.986,207.16,197.02,201.025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27242D"
    },
    d: "M195.362,201.286c-0.821-5.219-5.718-8.784-10.937-7.962c-0.078,0.012-0.156,0.026-0.234,0.04         c-5.091,0.929-8.537,5.757-7.728,10.897c0.821,5.219,5.718,8.784,10.937,7.962S196.183,206.505,195.362,201.286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3D8DE"
    },
    d: "M190.396,202.068c-0.603-3.829-4.195-6.444-8.024-5.842c-0.058,0.009-0.115,0.019-0.172,0.029         c-3.735,0.681-6.263,4.223-5.67,7.995c0.603,3.829,4.195,6.444,8.024,5.842C188.383,209.489,190.999,205.896,190.396,202.068         z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70BDC1"
    },
    d: "M176.469,202.577c0.255-3.097,2.557-5.743,5.731-6.322c0.057-0.01,0.114-0.02,0.172-0.029         c1.602-0.252,3.161,0.061,4.478,0.788c0.122,0.343,0.215,0.701,0.274,1.074c0.511,3.249-1.708,6.298-4.957,6.809         C179.909,205.252,177.749,204.288,176.469,202.577z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3781AA"
    },
    d: "M48.913,357.081H67.51c17.101,0,31.014-13.913,31.014-31.014v-17.909h11.785v17.909          c0,23.637-19.162,42.799-42.799,42.799H48.913V357.081z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#140B06"
    },
    points: "165.81,363.131 165.81,377.241 157.601,378.023 157.601,363.131         "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4690C1"
    },
    d: "M110.721,298.57v4.677c0,0.602-0.042,1.194-0.116,1.776h14.194          c23.637,0,42.799,19.162,42.799,42.799v16.781h-11.785v-16.781c0-17.101-13.913-31.014-31.014-31.014h-24.736          c-1.058,0.256-2.161,0.396-3.298,0.396c-7.708,0-13.956-6.248-13.956-13.956v-4.677H110.721z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 82.455,
    y: 299.191,
    style: {
      fill: "#7C433D"
    },
    width: 28.998,
    height: 4.652
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAA907"
    },
    d: "M103.738,300.059v2.853c0,0.949,0.75,1.721,1.671,1.721h4.007         c0.921,0,1.671-0.772,1.671-1.721v-2.853c0-0.949-0.75-1.721-1.671-1.721h-4.007         C104.488,298.338,103.738,299.11,103.738,300.059z M104.666,300.059c0-0.423,0.333-0.765,0.743-0.765h4.007         c0.41,0,0.743,0.342,0.743,0.765v2.853c0,0.422-0.332,0.765-0.743,0.765h-4.007c-0.41,0-0.743-0.343-0.743-0.765V300.059z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAA907"
    },
    d: "M103.195,301.507c0,0.352,0.211,0.637,0.471,0.637h4.082c0.26,0,0.471-0.285,0.471-0.637l0,0         c0-0.352-0.211-0.637-0.471-0.637h-4.082C103.406,300.87,103.195,301.155,103.195,301.507L103.195,301.507z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 96.179,
    y: 298.725,
    style: {
      fill: "#3781AA"
    },
    width: 2.248,
    height: 6.513
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.169,
    y: 298.725,
    style: {
      fill: "#3781AA"
    },
    width: 2.249,
    height: 6.513
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5876A"
    },
    d: "M130.128,197.236v10.141c0,2.023,1.018,3.345,4.043,3.345c0,0.371-0.165,0.682-0.137,0.681        c-0.61,0.43-1.456,0.318-2.263,0.318c-2.055,0-3.721-1.64-3.721-3.662v-7.572C128.05,199.045,128.898,197.833,130.128,197.236        z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#237396"
    },
    d: "M110.308,321.726v4.342c0,23.637-19.162,42.799-42.799,42.799H48.913v-4.342h18.596        C91.147,364.525,110.308,345.363,110.308,321.726z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B2416"
    },
    d: "M161.552,374.908c4.094,0,6.046-3.883,6.046-3.883c4.045,0,4.174,4.243,11.356,4.243l0,0         c4.786,0.083,7.598,0.852,7.598,4.816v7.541h-31.14v-3.655v-6.842v-3.655C155.412,372.442,157.02,374.908,161.552,374.908z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 48.151,
    y: 356.223,
    style: {
      fill: "#6FBBDD"
    },
    width: 5.793,
    height: 13.014
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3781AA"
    },
    d: "M100.594,314.351h26.158c18.084,0,32.796,17.737,32.796,33.686v10.89h8.05v5.706h-11.785        v-16.781c0-17.101-13.913-30.952-31.014-30.952h-24.736c-1.058,0.256-2.161,0.333-3.298,0.333        c-6.954,0-12.719-5.087-13.78-11.743C84.825,310.832,92.003,314.351,100.594,314.351z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.156,
    y: 359.627,
    style: {
      fill: "#8ECCED"
    },
    width: 13.014,
    height: 5.793
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#28160D"
    },
    points: "186.552,381.301 186.552,387.626 155.412,387.626 155.412,383.971 155.412,381.301               "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ECCED"
    },
    d: "M153.704,388.161v-1.59c0-1.145,0.928-2.074,2.074-2.074h30.408        c1.145,0,2.074,0.928,2.074,2.074v1.59H153.704z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5876A"
    },
    d: "M120.507,237.061c1.479,4.686,6.39,8.484,10.967,8.484s7.088-3.799,5.609-8.484        c-1.48-4.686-6.39-8.484-10.967-8.484C121.539,228.577,119.028,232.376,120.507,237.061z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B5A60"
    },
    d: "M165.744,186.281c0.265,1.686,1.847,2.837,3.533,2.572l7.885-1.241         c1.686-0.265,2.837-1.847,2.572-3.533l-2.962-18.823c-0.265-1.686-1.847-2.837-3.533-2.572l-7.885,1.241         c-1.686,0.265-2.837,1.847-2.572,3.533L165.744,186.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#87868E"
    },
    d: "M168.924,185.781c0.265,1.686,1.847,2.837,3.533,2.572l7.885-1.241         c1.686-0.265,2.837-1.847,2.572-3.533l-2.962-18.823c-0.265-1.686-1.847-2.837-3.533-2.572l-7.885,1.241         c-1.686,0.265-2.837,1.847-2.572,3.533L168.924,185.781z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DEBC79"
    },
    d: "M167.675,170.292c0.07,0.444,0.614,0.727,1.214,0.632l9.11-1.434         c0.601-0.094,1.031-0.531,0.961-0.975l-0.589-3.746c-0.07-0.444-0.614-0.727-1.214-0.633l-9.11,1.434         c-0.601,0.095-1.031,0.531-0.961,0.975L167.675,170.292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1984B"
    },
    d: "M178.964,168.665l-5.435-3.957l3.628-0.571c0.601-0.095,1.144,0.189,1.214,0.633l0.589,3.746         C178.968,168.565,178.968,168.615,178.964,168.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1984B"
    },
    d: "M167.142,166.91l-0.057-0.364c-0.07-0.444,0.361-0.88,0.961-0.975l0.509-0.08l6.195,4.51         l-2.765,0.435C170.372,169.261,168.757,168.085,167.142,166.91z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8,
      fill: "#F7E303"
    },
    points: "182.411,160.194 178.212,140.692 175.6,158.816 165.51,150.982        169.831,160.478 149.792,156.471 166.664,165.499 152.63,170.911 169.642,171.248 167.003,185.608 175.438,173.351        180.213,183.34 181.283,173.373 194.527,182.704 187.883,171.016 209.656,172.865 186.734,166.109 199.676,159.738        185.556,161.018 190.419,151.208      "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#945850"
    },
    d: "M104.579,267.664c2.981-2.366,6.241-6.165,8.606-10.539l2.758,2.758      c-2.686,4.029-5.936,7.455-8.776,9.574c-14.97,11.168-24.593,12.44-24.593,12.44l-0.238-2.341      C82.336,279.554,95.286,275.04,104.579,267.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7C433D"
    },
    d: "M110.302,231.651c1.748-0.07,7.266-0.228,10.41,7.746c4.287,10.872-5.906,25.25-13.307,30.772      c-14.97,11.168-24.593,12.44-24.593,12.44l-2.337-2.509c0,0,2.979-1.781,3.62-2.006c0,0-0.294,1.629-0.024,1.53      c3.955-1.437,13.459-5.463,20.746-11.247c6.385-5.068,14.052-16.709,11.465-26.496c-2.587-9.787-10.064-7.53-12.441-6.761      C106.567,233.442,110.302,231.651,110.302,231.651z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7C433D"
    },
    d: "M122.959,229.043c-3.635,0.008-6.845,0.731-8.541,1.033l5.014-1.948       c0.76-0.148,2.326-0.651,4.4-0.867L122.959,229.043z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7C433D"
    },
    d: "M123.903,266.153c3.732-1.432,8.485-4.119,13.002-9.172c4.395-4.917,7.225-16.694-2.03-24.064       l1.097-2.24c10.513,7.797,7.164,21.71,1.877,27.457c-8.325,9.049-16.526,12.482-19.801,13.57       C119.653,269.697,121.587,267.82,123.903,266.153z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34313A"
    },
    d: "M129.218,287.598c-0.49,0.49,14.138-0.8,14.138-0.8c3.878,0,7.021,3.143,7.021,7.021        c0,3.878-3.143,7.021-7.021,7.021c-1.175,0-14.138-0.8-14.138-0.8V287.598z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9D9D9E"
    },
    d: "M148.77,293.819c0-3.576-2.675-6.521-6.132-6.959c0.451-0.039,0.719-0.062,0.719-0.062         c3.878,0,7.021,3.143,7.021,7.021c0,3.878-3.143,7.021-7.021,7.021c-0.146,0-0.474-0.012-0.935-0.034         C145.983,300.467,148.77,297.469,148.77,293.819z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414D63"
    },
    d: "M140.858,292.667c0.336,0.781,0.324,1.474-0.059,1.474H127.7              c-0.383,0-0.395-0.693-0.059-1.474l3.365-7.813c0.075-0.175,0.267-0.31,0.431-0.31h5.623              c0.164,0,0.356,0.136,0.431,0.31L140.858,292.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27242D"
    },
    d: "M145.736,299.914c0,0.533-0.432,0.966-0.966,0.966h-18.24              c-0.533,0-0.966-0.432-0.966-0.966v-11.433c0-0.533,0.432-0.966,0.966-0.966h18.24c0.533,0,0.966,0.432,0.966,0.966              V299.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414D63"
    },
    d: "M140.602,298.877v2.037h4.168c0.533,0,0.966-0.432,0.966-0.966v-1.097h-5.139              C140.599,298.86,140.602,298.867,140.602,298.877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414D63"
    },
    d: "M144.771,287.502h-4.796v2.233h5.761v-1.267              C145.736,287.934,145.304,287.502,144.771,287.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34313A"
    },
    d: "M141.882,299.914c0,0.533-0.432,0.966-0.966,0.966h-18.24              c-0.533,0-0.966-0.432-0.966-0.966v-11.433c0-0.533,0.432-0.966,0.966-0.966h18.24c0.533,0,0.966,0.432,0.966,0.966              V299.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51617C"
    },
    d: "M141.882,289.723v-1.255c0-0.533-0.432-0.966-0.966-0.966h-18.24              c-0.533,0-0.966,0.432-0.966,0.966v1.255H141.882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51617C"
    },
    d: "M121.711,298.849v1.1c0,0.533,0.432,0.966,0.966,0.966h18.24              c0.533,0,0.966-0.432,0.966-0.966v-1.1H121.711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51617C"
    },
    d: "M136.892,289.154l-1.852-4.3c-0.075-0.175-0.267-0.31-0.432-0.31h-5.623              c-0.164,0-0.356,0.136-0.432,0.31l-1.852,4.3H136.892z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#242328"
    },
    d: "M133.11,287.027c0,0.194-0.202,0.352-0.451,0.352l-3.776,0             c-0.249,0-0.451-0.158-0.451-0.352l0-1.64c0-0.194,0.202-0.352,0.451-0.352h3.776c0.249,0,0.451,0.158,0.451,0.352             V287.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#151319"
    },
    d: "M134.199,287.027c0,0.194-0.202,0.352-0.451,0.352l-3.777,0             c-0.249,0-0.451-0.158-0.451-0.352v-1.64c0-0.194,0.202-0.352,0.451-0.352h3.776c0.249,0,0.451,0.158,0.451,0.352             V287.027z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2A700"
    },
    d: "M142.618,290.271v-0.881c0-0.212,0.172-0.384,0.384-0.384h1.775         c0.212,0,0.384,0.172,0.384,0.384v0.881h0.37v-0.881c0-0.416-0.339-0.754-0.755-0.754h-1.775         c-0.416,0-0.755,0.338-0.755,0.754v0.881H142.618z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#151319"
    },
    d: "M133.04,286.997c0.174-0.026,0.308-0.133,0.308-0.267v-1.297c0-0.134-0.134-0.241-0.308-0.267        v-0.407h0.572c0.297,0,0.538,0.178,0.538,0.397v1.851c0,0.219-0.241,0.397-0.538,0.397h-0.572V286.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34313A"
    },
    d: "M128.005,285.156v1.851c0,0.219,0.241,0.397,0.538,0.397h4.502        c0.297,0,0.538-0.178,0.538-0.397v-1.851c0-0.219-0.241-0.397-0.538-0.397h-4.502        C128.245,284.759,128.005,284.936,128.005,285.156z M128.806,285.433c0-0.154,0.171-0.278,0.383-0.278h3.208        c0.212,0,0.383,0.125,0.383,0.278v1.297c0,0.154-0.172,0.278-0.383,0.278h-3.208c-0.212,0-0.383-0.125-0.383-0.278V285.433z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.188,
    y: 290.382,
    style: {
      fill: "#70BDC1"
    },
    width: 13.925,
    height: 7.8
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M135.772,290.382h1.925c1.139,1.139,2.277,2.277,3.416,3.416v1.925        C139.333,293.942,137.552,292.162,135.772,290.382z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M127.188,291.32v-0.938h2.613l7.8,7.8h-3.552        C131.762,295.895,129.475,293.607,127.188,291.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M127.188,295.292v-2.212c1.701,1.701,3.401,3.401,5.102,5.102h-2.212        L127.188,295.292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51617C"
    },
    d: "M123.613,293.35c0,0.411,0.247,0.743,0.551,0.743c0.304,0,0.551-0.333,0.551-0.743        c0-0.41-0.247-0.743-0.551-0.743C123.86,292.607,123.613,292.94,123.613,293.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51617C"
    },
    d: "M124.92,294.606c0,0.41,0.247,0.743,0.551,0.743s0.551-0.333,0.551-0.743        c0-0.411-0.247-0.743-0.551-0.743S124.92,294.196,124.92,294.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51617C"
    },
    d: "M122.268,294.606c0,0.41,0.247,0.743,0.551,0.743c0.304,0,0.551-0.333,0.551-0.743        c0-0.411-0.247-0.743-0.551-0.743C122.514,293.863,122.268,294.196,122.268,294.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51617C"
    },
    d: "M123.613,295.836c0,0.41,0.247,0.743,0.551,0.743c0.304,0,0.551-0.333,0.551-0.743        s-0.247-0.743-0.551-0.743C123.86,295.093,123.613,295.426,123.613,295.836z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#682923"
    },
    d: "M140.003,236.192c-0.875-1.657-1.992-3.157-3.329-4.424c4.806,1.262,8.357,5.624,8.357,10.826        v46.621h-2.299v-46.621C142.732,240.082,141.682,237.813,140.003,236.192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#682923"
    },
    d: "M124.917,265.435v22.066h-2.299v-20.413C123.337,266.512,124.114,265.966,124.917,265.435z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414D63"
    },
    d: "M114.919,332.485c0.39,0.905,0.376,1.71-0.068,1.71H99.657             c-0.444,0-0.458-0.804-0.068-1.71l3.903-9.062c0.087-0.203,0.31-0.36,0.5-0.36h6.522c0.191,0,0.413,0.158,0.5,0.36             L114.919,332.485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27242D"
    },
    d: "M120.578,340.89c0,0.619-0.501,1.12-1.12,1.12H98.302c-0.619,0-1.12-0.501-1.12-1.12             v-13.26c0-0.619,0.501-1.12,1.12-1.12h21.156c0.619,0,1.12,0.501,1.12,1.12V340.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414D63"
    },
    d: "M114.623,339.688v2.363h4.835c0.619,0,1.12-0.501,1.12-1.12v-1.272h-5.961             C114.619,339.668,114.623,339.677,114.623,339.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414D63"
    },
    d: "M119.458,326.494h-5.563v2.59h6.683v-1.47             C120.578,326.995,120.076,326.494,119.458,326.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34313A"
    },
    d: "M116.108,340.89c0,0.619-0.502,1.12-1.12,1.12H93.831c-0.619,0-1.12-0.501-1.12-1.12             v-13.26c0-0.619,0.501-1.12,1.12-1.12h21.156c0.619,0,1.12,0.501,1.12,1.12V340.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51617C"
    },
    d: "M116.108,329.07v-1.456c0-0.619-0.502-1.12-1.12-1.12H93.831             c-0.619,0-1.12,0.501-1.12,1.12v1.456H116.108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51617C"
    },
    d: "M92.711,339.655v1.276c0,0.619,0.501,1.12,1.12,1.12h21.156c0.619,0,1.12-0.501,1.12-1.12             v-1.276H92.711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51617C"
    },
    d: "M110.319,328.41l-2.148-4.988c-0.087-0.203-0.31-0.36-0.5-0.36h-6.522             c-0.191,0-0.413,0.158-0.5,0.36L98.5,328.41H110.319z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3D8DE"
    },
    d: "M107.296,325.943c0,0.225-0.247,0.408-0.552,0.408h-4.628            c-0.305,0-0.553-0.183-0.553-0.408l0-1.903c0-0.226,0.247-0.408,0.553-0.408h4.628c0.305,0,0.553,0.183,0.553,0.408            V325.943z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70BDC1"
    },
    d: "M101.573,326.018l2.385-2.385h-1.843c-0.305,0-0.553,0.183-0.553,0.408l0,1.903           C101.563,325.969,101.567,325.993,101.573,326.018z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70BDC1"
    },
    d: "M107.296,324.225v-0.185c0-0.226-0.247-0.408-0.553-0.408h-0.259l-2.719,2.719h1.404           C105.878,325.643,106.587,324.934,107.296,324.225z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27242D"
    },
    d: "M96.659,334.206c0-4.207-1.117-7.625,3.077-7.68c0.035,0,4.569-0.001,4.604-0.001          c4.242,0,7.681,3.439,7.681,7.681c0,4.242-3.439,7.681-7.681,7.681c-0.035,0-4.758,0-4.792-0.001          C95.354,341.831,96.659,338.413,96.659,334.206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9D9D9E"
    },
    d: "M102.716,326.525c-0.013,0-0.656,0-1.458,0c4.241,0.001,7.679,3.439,7.679,7.681          c0,4.242-3.438,7.68-7.68,7.681c0.807,0,1.445,0,1.458,0c4.242,0,7.681-3.439,7.681-7.681          C110.397,329.964,106.958,326.525,102.716,326.525z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27242D"
    },
    d: "M90.003,334.13c0-5.183-1.376-9.393,3.791-9.461c0.043-0.001,5.629-0.001,5.672-0.001          c5.226,0,9.462,4.236,9.462,9.462c0,5.226-4.236,9.462-9.462,9.462c-0.043,0-5.861,0-5.904-0.001          C88.394,343.524,90.003,339.314,90.003,334.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9D9D9E"
    },
    d: "M97.464,324.668c-0.016,0-0.808,0-1.796,0c5.225,0.001,9.46,4.237,9.46,9.462          c0,5.225-4.235,9.461-9.46,9.462c0.994,0,1.781,0,1.796,0c5.226,0,9.462-4.236,9.462-9.462          C106.926,328.905,102.69,324.668,97.464,324.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E5"
    },
    d: "M84.22,334.13c0-5.226,4.236-9.462,9.462-9.462c0.079,0,0.157,0.001,0.235,0.003          c5.117,0.125,9.227,4.312,9.227,9.459c0,5.226-4.236,9.462-9.462,9.462C88.456,343.593,84.22,339.356,84.22,334.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27242D"
    },
    d: "M85.633,334.13c0-4.446,3.604-8.049,8.049-8.049c0.067,0,0.133,0.001,0.2,0.002          c4.353,0.106,7.85,3.668,7.85,8.047c0,4.446-3.604,8.049-8.049,8.049C89.237,342.18,85.633,338.576,85.633,334.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3D8DE"
    },
    d: "M89.863,334.13c0-3.262,2.644-5.906,5.906-5.906c0.049,0,0.098,0.001,0.147,0.002          c3.194,0.078,5.759,2.691,5.759,5.904c0,3.262-2.644,5.906-5.906,5.906C92.507,340.036,89.863,337.392,89.863,334.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70BDC1"
    },
    d: "M101.506,332.732c-0.617-2.541-2.877-4.439-5.591-4.505          c-0.049-0.001-0.098-0.002-0.147-0.002c-1.364,0-2.619,0.464-3.619,1.241c-0.057,0.301-0.087,0.611-0.087,0.929          c0,2.768,2.244,5.012,5.012,5.012C98.997,335.406,100.666,334.322,101.506,332.732z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2A700"
    },
    d: "M116.961,329.705v-1.022c0-0.246,0.2-0.446,0.446-0.446h2.059c0.246,0,0.446,0.2,0.446,0.446        v1.022h0.429v-1.022c0-0.483-0.393-0.875-0.875-0.875h-2.059c-0.483,0-0.875,0.392-0.875,0.875v1.022H116.961z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#682923"
    },
    d: "M99.143,245.145v79.523c-0.468,0-1.39,0-2.345,0v-79.523c0-6.315,5.119-11.434,11.434-11.434       s11.434,5.119,11.434,11.434v83.466h-2.345v-83.466c0-5.011-4.077-9.088-9.088-9.088       C103.22,236.057,99.143,240.134,99.143,245.145z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#719B51"
    },
    d: "M115.047,239.415c-3.911-7.503-18.214-0.54-12.899,7.518      c38.341,58.129,79.306-14.78,79.306-14.78l-8.6-4.342C172.855,227.811,139.161,285.676,115.047,239.415z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#668C44"
    },
    d: "M178.675,230.78l2.779,1.403c0,0-37.275,66.34-73.991,22.001       C142.324,286.563,169.49,243.843,178.675,230.78z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90BA6A"
    },
    d: "M115.047,239.415c19.731,37.854,45.877,5.989,54.728-6.843c0.12,0.12,0.24,0.24,0.361,0.361      c-5.394,8.561-35.103,52.115-56.949,10.204c-2.44-4.681-8.924-3.731-12.166-0.397      C101.685,236.827,111.845,233.272,115.047,239.415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7C433D"
    },
    d: "M100.558,230.275c0.004-0.111,0.107-3.405,2.03-5.029c0.648-0.548,8.358-1.915,10.883-2.264      c-1.559-1.061-4.285-1.76-4.285-1.76s-8.984,1.105-10.255,2.108c-1.654,1.306-2.177,4.092-2.177,4.092L100.558,230.275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#682923"
    },
    d: "M84.513,261.776c-2.361-0.506-12.314-3.374-15.519-7.59      C76.248,257.221,84.513,261.776,84.513,261.776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#945850"
    },
    d: "M84.513,261.776c-2.361-0.506-12.314-3.374-15.519-7.59c-1.741,5.131-9.779,27.977,6.615,26.285      C80.835,279.93,84.513,261.776,84.513,261.776z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M160.201,244.442c7.236-8.311,14.805-21.663,14.805-21.663l11.709,4.573    c0,0-10.424,14.813-19.546,24.057L160.201,244.442z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#682923"
    },
    points: "174.092,229.054 171.867,227.264 168.481,232.343 171.673,234.471    "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27242D"
    },
    d: "M176.176,239.357c3.171,0,5.75-2.58,5.75-5.75c0-3.171-2.58-5.751-5.75-5.751      c-3.171,0-5.751,2.58-5.751,5.751C170.425,236.777,173.005,239.357,176.176,239.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34313A"
    },
    d: "M176.962,239.478c3.071,0,5.569-2.498,5.569-5.569c0-3.071-2.498-5.57-5.569-5.57      c-3.071,0-5.57,2.498-5.57,5.57C171.392,236.98,173.891,239.478,176.962,239.478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M172.208,233.909c0,2.625,2.128,4.754,4.754,4.754c2.625,0,4.754-2.128,4.754-4.754      c0-2.625-2.128-4.754-4.754-4.754C174.337,229.155,172.208,231.284,172.208,233.909z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 176.703,
    y: 230.311,
    style: {
      fill: "#34313A"
    },
    width: 0.871,
    height: 3.676
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.134,
    y: 235.63,
    transform: "matrix(0.3026 -0.9531 0.9531 0.3026 -101.7393 332.7389)",
    style: {
      fill: "#34313A"
    },
    width: 4.725,
    height: 0.52
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34313A"
    },
    d: "M177.2,239.937c1.133,1.664-0.988,5.468-7.675,0.106c-5.153-4.132-3.112-7.659-0.97-6.67   c-0.577,0.824-0.774,1.145-0.774,1.145s1.583,4.688,8.339,6.748L177.2,239.937z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M172.178,241.674c0.556,0,1.007-0.451,1.007-1.007c0-0.301-0.139-0.564-0.349-0.748   c0.268-0.145,0.571-0.235,0.897-0.235c1.05,0,1.902,0.852,1.902,1.902c0,1.05-0.852,1.902-1.902,1.902   c-1.044,0-1.89-0.842-1.9-1.884C171.942,241.645,172.056,241.674,172.178,241.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M167.588,237.874c0.518,0.202,1.102-0.053,1.304-0.571c0.11-0.281,0.076-0.576-0.053-0.824   c0.303-0.037,0.617-0.011,0.921,0.108c0.978,0.383,1.461,1.486,1.079,2.464c-0.383,0.978-1.486,1.461-2.464,1.079   c-0.973-0.38-1.454-1.473-1.083-2.447C167.378,237.76,167.474,237.829,167.588,237.874z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1411F"
    },
    d: "M324.686,168.56c0,0,71.948,4.033,71.948,16.039c0,6.493,13.551-17.526,13.551-17.526l-85.5-7.275    V168.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E385"
    },
    d: "M418.084,166.52c0,0-60.17,5.448-60.17,17.454c0,6.493-13.551-18.563-13.551-18.563l72.634-5.952    L418.084,166.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1411F"
    },
    d: "M396.634,177.096c0-6.888,5.584-12.472,12.472-12.472H414c6.888,0,12.471,5.584,12.471,12.472    v68.765c0,6.888-5.584,12.472-12.471,12.472h-4.894c-6.888,0-12.472-5.584-12.472-12.472V177.096z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M411.829,165.213c-5.101,0-10.572,4.233-12.221,9.454c-1.649,5.222,1.15,9.454,6.25,9.454     c5.1,0,10.572-4.233,12.22-9.454C419.728,169.446,416.929,165.213,411.829,165.213z M416.885,173.548     c-1.384,4.377-5.979,7.924-10.261,7.924c-4.283,0-6.633-3.548-5.248-7.924c1.384-4.377,5.979-7.924,10.262-7.924     S418.27,169.171,416.885,173.548z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.086,
    y: 148.736,
    transform: "matrix(0.898 -0.4399 0.4399 0.898 -29.5799 194.7808)",
    style: {
      fill: "#E5876A"
    },
    width: 12.641,
    height: 24.934
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M408.499,152.357c0,9.697-7.861,17.558-17.558,17.558h-5.175c-9.697,0-17.558-7.861-17.558-17.558     v-27.97c0-9.697,7.861-17.558,17.558-17.558h5.175c9.697,0,17.558,7.861,17.558,17.558V152.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5876A"
    },
    d: "M400.719,109.804c0.09,0.632,0.137,1.318,0.137,2.063v0.6c1.59,2.641,2.506,5.733,2.506,9.04     l-0.221,27.75c0,9.697-7.641,17.779-17.338,17.779h-5.175c-2.066,0-4.047-0.359-5.887-1.014     c3.013,2.436,6.847,3.896,11.024,3.896h5.175c9.697,0,17.558-6.652,17.558-16.35v-29.179     C408.499,118.311,405.411,112.956,400.719,109.804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M371.885,153.938c0.445,4.407,3.073,7.793,6.253,7.793h1.864c3.18,0,5.808-3.386,6.253-7.793     C384.141,153.938,373.678,153.938,371.885,153.938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5876A"
    },
    d: "M375.264,146.957c0.052,1.691,1.24,3.043,2.699,3.043h0.796c1.459,0,2.647-1.352,2.699-3.043     H375.264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34313A"
    },
    d: "M401.106,120.013c0,0,0.59,3.208,0.479,5.665l8.352-4.72c0.428-2.809,2.203-6.724-0.699-8.584     c-3.327-16.634-31.081-23.612-40.105-9.217c-4.365,6.963-8.938,3.638-8.938,2.079c-8.314,0-11.432,18.72,7.273,18.72h26.984     C398.395,123.956,401.106,120.013,401.106,120.013z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34313A"
    },
    d: "M392.559,133.947c0,0.755-0.612,1.366-1.366,1.366h-9.196c-0.754,0-1.366-0.612-1.366-1.366l0,0     c0-0.754,0.612-1.366,1.366-1.366h9.196C391.948,132.581,392.559,133.192,392.559,133.947L392.559,133.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34313A"
    },
    d: "M376.667,133.947c0,0.755-0.612,1.366-1.366,1.366h-6.564c-0.754,0-1.366-0.612-1.366-1.366l0,0     c0-0.754,0.612-1.366,1.366-1.366h6.564C376.055,132.581,376.667,133.192,376.667,133.947L376.667,133.947z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#34313A"
    },
    cx: 371.828,
    cy: 139.313,
    r: 1.608
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34313A"
    },
    d: "M387.199,139.313c0,0.888-0.72,1.608-1.608,1.608c-0.888,0-1.608-0.72-1.608-1.608     s0.72-1.608,1.608-1.608C386.479,137.705,387.199,138.425,387.199,139.313z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27242D"
    },
    d: "M397.208,115.803c-3.943,0-23.334,0-31.713,0c-8.522,0-10.913-8.593-5.3-10.567      c-8.834,0-11.432,18.72,7.273,18.72c8.379,0,23.041,0,26.984,0c3.943,0,6.654-3.943,6.654-3.943      S401.151,115.803,397.208,115.803z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M409.451,144.502c0,2.041-1.655,3.696-3.696,3.696l0,0c-2.041,0-3.696-1.655-3.696-3.696v-7.642     c0-2.041,1.655-3.696,3.696-3.696l0,0c2.041,0,3.696,1.655,3.696,3.696V144.502z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7366 -0.6764 0.6764 0.7366 -10.0929 322.4107)",
    style: {
      fill: "#E5876A"
    },
    cx: 408.844,
    cy: 174.162,
    rx: 10.023,
    ry: 7.285
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4690C1"
    },
    d: "M396.634,245.209v0.652c0,6.888,5.584,12.472,12.472,12.472H414    c6.888,0,12.472-5.584,12.472-12.472v-0.652H396.634z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 396.103,
    y: 241.016,
    style: {
      fill: "#7C433D"
    },
    width: 30.867,
    height: 4.952
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAA907"
    },
    d: "M404.766,240.108H400.5c-0.981,0-1.779,0.822-1.779,1.833v3.037c0,1.01,0.798,1.832,1.779,1.832     h4.266c0.981,0,1.779-0.822,1.779-1.832v-3.037C406.545,240.93,405.747,240.108,404.766,240.108z M405.556,244.977     c0,0.45-0.354,0.814-0.79,0.814H400.5c-0.437,0-0.791-0.365-0.791-0.814v-3.037c0-0.45,0.354-0.814,0.791-0.814h4.266     c0.437,0,0.79,0.365,0.79,0.814V244.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAA907"
    },
    d: "M407.122,243.482c0,0.375-0.224,0.678-0.501,0.678h-4.346c-0.277,0-0.501-0.304-0.501-0.678l0,0     c0-0.375,0.225-0.678,0.501-0.678h4.346C406.898,242.803,407.122,243.107,407.122,243.482L407.122,243.482z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 409.969,
    y: 240.52,
    style: {
      fill: "#3781AA"
    },
    width: 2.393,
    height: 6.933
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.07,
    y: 240.52,
    style: {
      fill: "#3781AA"
    },
    width: 1.382,
    height: 6.933
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.689,
    y: 240.52,
    style: {
      fill: "#3781AA"
    },
    width: 2.393,
    height: 6.933
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 411.656,
    y: 249.104,
    style: {
      fill: "#4690C1"
    },
    width: 12.009,
    height: 113.358
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#140B06"
    },
    points: "414.688,362.244 414.688,376.622 423.053,377.419 423.053,362.244   "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B2416"
    },
    d: "M421.964,374.245c-4.171,0-4.539-2.578-6.097-3.538c-5.457-3.364-7.851,3.905-12.887,3.905     c-0.629,0-1.316,0-1.823,0c-0.953,0-4.275,0.868-4.275,4.907l0,7.684h28.401v-3.724v-6.972c0,0,0.076-4.831-2.072-4.831     C422.16,371.677,422.796,374.245,421.964,374.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#28160D"
    },
    d: "M425.283,382.148h-13c-1.745,0-3.16-1.415-3.16-3.16c0-3.295,1.099-4.296-6.383-4.296     c-3.756,0-5.858,1.329-5.858,4.828v7.684h28.401v-3.724V382.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6FBBDD"
    },
    d: "M427.023,387.749v-1.62c0-1.167-0.946-2.113-2.113-2.113h-27.655     c-1.167,0-2.113,0.946-2.113,2.113v1.62H427.023z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 411.05,
    y: 358.897,
    style: {
      fill: "#6FBBDD"
    },
    width: 13.262,
    height: 5.903
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3781AA"
    },
    d: "M422.5,350.45c-0.403-0.164-0.789-0.374-1.67-0.661c-18.316-5.976-27.891-23.162-23.054-39.81    l13.88-46.985v-4.662h-2.55c-2.625,0-5.057-0.815-7.066-2.199l-14.644,49.572c-6.567,22.596,6.427,46.237,29.023,52.803    c0.171,0.05,0.342,0.088,0.514,0.136c1.891-1.891,3.781-3.781,5.672-5.672C422.57,352.132,422.526,351.291,422.5,350.45z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#140B06"
    },
    points: "417.464,358.433 430.034,365.411 434.792,358.484 421.524,351.119   "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.029,
    y: 353.122,
    transform: "matrix(0.4378 -0.8991 0.8991 0.4378 -83.6338 578.4099)",
    style: {
      fill: "#8ECCED"
    },
    width: 13.261,
    height: 5.908
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B2416"
    },
    d: "M429.517,360.471c0.002,4.171-3.953,6.163-3.953,6.163c0.002,4.122,4.326,4.251,4.33,11.57l0,0     c0.088,4.877,0.873,7.742,4.911,7.74l7.684-0.004l-0.018-31.732l-3.724,0.002l-6.972,0.004l-3.724,0.002     C427,354.216,429.514,355.853,429.517,360.471z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#28160D"
    },
    points: "436.045,385.943 442.49,385.939 442.472,354.207 438.747,354.209 436.027,354.211   "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ECCED"
    },
    d: "M443.016,352.466l-1.62,0.001c-1.167,0.001-2.112,0.947-2.112,2.114l0.018,30.986    c0.001,1.167,0.947,2.112,2.114,2.112l1.62-0.001L443.016,352.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1411F"
    },
    d: "M421.648,167.244c-3.319-3.303-1.912,15.391,1.424,18.676    c22.657,22.31,19.954,26.675,16.421,31.456l-23.357,29.255l5.738,5.738l25.518-30.628    C456.33,212.595,450.718,196.174,421.648,167.244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M410.724,248.941c-0.201-1.542,0.887-2.955,2.429-3.155l4.736-0.961    c1.542-0.201,5.694,4.001,5.895,5.543l-1.547,2.263c0.201,1.542-0.887,2.955-2.429,3.155L410.724,248.941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34313A"
    },
    d: "M401.597,143.777c-0.808,0-1.464,0.655-1.464,1.464c0,0,0,0.605,0,1.352    c0,0.747,0.025,1.504,0.041,1.693c0.01,0.113,0.016,0.227,0.016,0.343v7.435c0,2.52-2.043,4.563-4.563,4.563    c-2.52,0-4.563-2.043-4.563-4.563v-4.01c0-1.378-1.117-2.494-2.494-2.494h-17.869c-1.378,0-2.494,0.626-2.494,1.399v1.399    c0,9.697,7.861,17.558,17.558,17.558h5.175c2.964,0,6.207-0.457,8.911-1.597c1.269-0.535,2.381-1.225,2.571-1.355    c0.114-0.079,0.217-0.173,0.305-0.281c0.213-0.271,0.334-0.58,0.334-0.92v-20.522C403.06,144.432,402.405,143.777,401.597,143.777    z M380.565,163.819h-2.299c-4.342,0-7.934-4.357-8.54-10.36c0,0-0.022-0.915,0.896-0.915h17.5c0.918,0,0.982,0.915,0.982,0.915    C388.498,159.462,384.907,163.819,380.565,163.819z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#844741"
    },
    points: "338.083,362.462 338.083,249.104 326.074,247.453 326.074,362.462     "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M280.767,160.504c0.263,0.932-0.279,1.902-1.212,2.165l0,0c-0.932,0.263-1.902-0.279-2.165-1.212      l-4.57-16.185c-0.263-0.933,0.279-1.902,1.212-2.165l0,0c0.932-0.263,1.902,0.279,2.165,1.212L280.767,160.504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M283.922,161.258c-0.126,0.961-1.007,1.637-1.968,1.511l0,0      c-0.961-0.126-1.637-1.007-1.511-1.968l2.187-16.675c0.126-0.961,1.007-1.637,1.968-1.511l0,0      c0.961,0.126,1.637,1.007,1.511,1.968L283.922,161.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M272.224,161.623c-1.608,0.655-1.384,7.697-0.211,8.979l1.721,3.784      c1.173,1.283,8.596,1.535,9.879,0.365l3.914-4.841c0.99-2.322,2.589-3.834-3.362-10.507      C284.165,159.403,274.826,160.564,272.224,161.623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA8060"
    },
    d: "M280.017,167.997c-1.007,0.38-2.132-0.129-2.512-1.136l-1.793-4.751      c-0.066-0.175-0.096-0.353-0.111-0.53c-0.142,0.414-0.154,0.875,0.012,1.316l1.793,4.751c0.38,1.007,1.505,1.516,2.512,1.136      c0.833-0.314,1.315-1.137,1.246-1.982C280.983,167.332,280.583,167.783,280.017,167.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA8060"
    },
    d: "M279.373,161.843c-0.39,1.001,0.105,2.129,1.105,2.52l4.717,1.841      c0.173,0.068,0.35,0.1,0.527,0.116c-0.414,0.137-0.874,0.144-1.312-0.027l-4.717-1.842c-1-0.39-1.495-1.518-1.105-2.52      c0.322-0.827,1.148-1.3,1.99-1.222C280.047,160.886,279.592,161.28,279.373,161.843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA8060"
    },
    d: "M276.413,169.144c-1.007,0.38-2.132-0.129-2.512-1.136l-1.793-4.751      c-0.066-0.175-0.096-0.352-0.111-0.53c-0.142,0.414-0.154,0.875,0.012,1.316l1.793,4.751c0.38,1.007,1.505,1.516,2.512,1.136      c0.833-0.314,1.315-1.137,1.246-1.982C277.379,168.478,276.979,168.93,276.413,169.144z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E385"
    },
    d: "M319.542,174.386c-0.608,17.362-9.564,29.302-17.633,29.302c-8.069,0-17.025-11.939-17.633-29.302     h-10.812c0.667,22.317,13.144,40.111,28.445,40.111c15.3,0,27.778-17.793,28.445-40.111H319.542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E385"
    },
    d: "M319.542,174.386c0-6.888,11.228-9.762,18.116-9.762h4.894c6.888,0,17.025,2.663,17.025,9.551     l-4.554,71.686c0,6.888-5.584,12.472-12.472,12.472h-4.894c-6.888,0-12.472-5.584-12.472-12.472L319.542,174.386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#945850"
    },
    d: "M325.186,245.209v0.713c0,7.538,5.584,13.649,12.472,13.649h4.894     c6.888,0,12.472-6.111,12.472-13.649v-0.713H325.186z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 324.656,
    y: 241.016,
    style: {
      fill: "#7C433D"
    },
    width: 30.867,
    height: 4.952
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAA907"
    },
    d: "M333.318,240.108h-4.266c-0.981,0-1.779,0.822-1.779,1.833v3.037c0,1.01,0.798,1.832,1.779,1.832      h4.266c0.981,0,1.779-0.822,1.779-1.832v-3.037C335.097,240.93,334.299,240.108,333.318,240.108z M334.109,244.977      c0,0.45-0.354,0.814-0.791,0.814h-4.266c-0.437,0-0.79-0.365-0.79-0.814v-3.037c0-0.45,0.354-0.814,0.79-0.814h4.266      c0.437,0,0.791,0.365,0.791,0.814V244.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAA907"
    },
    d: "M335.674,243.482c0,0.375-0.224,0.678-0.501,0.678h-4.346c-0.277,0-0.501-0.304-0.501-0.678l0,0      c0-0.375,0.225-0.678,0.501-0.678h4.346C335.45,242.803,335.674,243.107,335.674,243.482L335.674,243.482z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 338.521,
    y: 240.52,
    style: {
      fill: "#945850"
    },
    width: 2.393,
    height: 6.933
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.623,
    y: 240.52,
    style: {
      fill: "#945850"
    },
    width: 1.382,
    height: 6.933
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.241,
    y: 240.52,
    style: {
      fill: "#945850"
    },
    width: 2.393,
    height: 6.933
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#140B06"
    },
    points: "329.106,362.244 329.105,376.622 337.471,377.419 337.471,362.244    "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#273447"
    },
    d: "M336.382,374.245c-4.171,0-4.539-2.578-6.097-3.538c-5.457-3.364-7.851,3.905-12.887,3.905      c-0.629,0-1.316,0-1.823,0c-0.953,0-4.275,0.868-4.275,4.907v7.684h28.401v-3.724v-6.972c0,0,0.076-4.831-2.072-4.831      C336.577,371.677,337.213,374.245,336.382,374.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D2C3D"
    },
    d: "M339.701,382.148h-13c-1.745,0-3.16-1.415-3.16-3.16c0-3.295,1.099-4.296-6.383-4.296      c-3.756,0-5.858,1.329-5.858,4.828v7.684h28.401v-3.724V382.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#140B06"
    },
    d: "M341.441,387.749v-1.62c0-1.167-0.946-2.113-2.113-2.113h-27.655      c-1.167,0-2.113,0.946-2.113,2.113v1.62H341.441z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 325.468,
    y: 358.897,
    style: {
      fill: "#BA7068"
    },
    width: 13.262,
    height: 5.903
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.455,
    y: 249.104,
    style: {
      fill: "#945850"
    },
    width: 12.009,
    height: 113.358
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#140B06"
    },
    points: "344.487,362.244 344.487,376.622 352.852,377.419 352.852,362.244    "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#273447"
    },
    d: "M351.763,374.245c-4.171,0-4.539-2.578-6.097-3.538c-5.457-3.364-7.851,3.905-12.887,3.905     c-0.629,0-1.316,0-1.823,0c-0.953,0-4.275,0.868-4.275,4.907l0,7.684h28.401v-3.724v-6.972c0,0,0.076-4.831-2.072-4.831     C351.959,371.677,352.595,374.245,351.763,374.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D2C3D"
    },
    d: "M355.083,382.148h-13c-1.745,0-3.16-1.415-3.16-3.16c0-3.295,1.099-4.296-6.383-4.296     c-3.756,0-5.858,1.329-5.858,4.828v7.684h28.401v-3.724V382.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#140B06"
    },
    d: "M356.823,387.749v-1.62c0-1.167-0.946-2.113-2.113-2.113h-27.655     c-1.167,0-2.113,0.946-2.113,2.113v1.62H356.823z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.849,
    y: 358.897,
    style: {
      fill: "#BA7068"
    },
    width: 13.262,
    height: 5.903
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M426.168,178.274c0.014,1.031,0.861,1.855,1.891,1.842l0,0c1.031-0.014,1.855-0.861,1.842-1.891     l-0.114-8.503c-0.014-1.031-0.861-1.855-1.891-1.842l0,0c-1.031,0.014-1.855,0.861-1.842,1.891L426.168,178.274z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M432.961,167.596c0.287,2.558-2.071,3.21-2.812,3.691l0,0c-2.559,1.762-6.062,1.116-7.824-1.443      l-5.323-7.73c-1.762-2.559-0.298-2.707,2.969-2.67l0,0c3.266,0.037,11.169,2.951,12.498,5.76      C432.811,165.925,432.961,167.596,432.961,167.596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M429.352,180.054c0.014,1.031,0.861,1.856,1.891,1.842l0,0c1.031-0.014,1.855-0.861,1.842-1.891      l-0.113-12.232c-0.014-1.031-0.861-1.855-1.891-1.842l0,0c-1.031,0.014-1.855,0.861-1.842,1.892L429.352,180.054z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M422.714,176.969c0.014,1.031,0.861,1.855,1.891,1.842l0,0c1.031-0.014,1.855-0.861,1.842-1.891      l-0.113-8.503c-0.014-1.031-0.861-1.855-1.892-1.842l0,0c-1.031,0.014-1.855,0.861-1.842,1.892L422.714,176.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M416.479,168.745c0.262,1.211,1.456,1.981,2.666,1.719l0,0c1.21-0.262,1.979-1.456,1.717-2.667      l-1.117-6.469c-0.262-1.211-1.456-1.981-2.666-1.719l0,0c-1.21,0.262-1.979,1.456-1.717,2.667L416.479,168.745z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M319.705,178.274c-0.014,1.031-0.861,1.855-1.892,1.842l0,0c-1.031-0.014-1.855-0.861-1.842-1.891     l0.113-8.503c0.014-1.031,0.861-1.855,1.892-1.842l0,0c1.031,0.014,1.855,0.861,1.842,1.891L319.705,178.274z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M312.911,167.596c-0.287,2.558,2.071,3.21,2.812,3.691l0,0c2.559,1.762,6.063,1.116,7.824-1.443      l5.323-7.73c1.762-2.559,0.298-2.707-2.969-2.67l0,0c-3.266,0.037-11.169,2.951-12.498,5.76      C313.061,165.925,312.911,167.596,312.911,167.596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M316.52,180.054c-0.014,1.031-0.861,1.856-1.892,1.842l0,0c-1.031-0.014-1.855-0.861-1.842-1.891      l0.113-12.232c0.014-1.031,0.861-1.855,1.891-1.842l0,0c1.031,0.014,1.855,0.861,1.842,1.892L316.52,180.054z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M323.158,176.969c-0.014,1.031-0.861,1.855-1.892,1.842l0,0      c-1.031-0.014-1.855-0.861-1.842-1.891l0.113-8.503c0.014-1.031,0.861-1.855,1.891-1.842l0,0      c1.031,0.014,1.855,0.861,1.842,1.892L323.158,176.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M329.394,168.745c-0.262,1.211-1.456,1.981-2.666,1.719l0,0c-1.21-0.262-1.979-1.456-1.717-2.667      l1.117-6.469c0.262-1.211,1.456-1.981,2.666-1.719l0,0c1.21,0.262,1.979,1.456,1.717,2.667L329.394,168.745z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 327.638,
    y: 148.736,
    transform: "matrix(0.898 -0.4399 0.4399 0.898 -36.8648 163.3484)",
    style: {
      fill: "#E5876A"
    },
    width: 12.641,
    height: 24.934
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M337.051,152.357c0,9.697-7.861,17.558-17.558,17.558h-5.175c-9.697,0-17.558-7.861-17.558-17.558    v-27.97c0-9.697,7.861-17.558,17.558-17.558h5.175c9.697,0,17.558,7.861,17.558,17.558V152.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5876A"
    },
    d: "M329.271,109.804c0.09,0.632,0.137,1.318,0.137,2.063v0.6c1.59,2.641,2.506,5.733,2.506,9.04    l-0.22,27.75c0,9.697-7.641,17.779-17.338,17.779h-5.175c-2.066,0-4.047-0.359-5.887-1.014c3.014,2.436,6.847,3.896,11.024,3.896    h5.175c9.697,0,17.558-6.652,17.558-16.35v-29.179C337.051,118.311,333.963,112.956,329.271,109.804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M300.437,153.938c0.445,4.407,3.073,7.793,6.253,7.793h1.864c3.18,0,5.808-3.386,6.253-7.793    C312.693,153.938,302.23,153.938,300.437,153.938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5876A"
    },
    d: "M303.816,146.957c0.052,1.691,1.24,3.043,2.699,3.043h0.796c1.459,0,2.647-1.352,2.699-3.043    H303.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34313A"
    },
    d: "M321.111,133.947c0,0.755-0.612,1.366-1.366,1.366h-9.196c-0.754,0-1.366-0.612-1.366-1.366l0,0    c0-0.754,0.612-1.366,1.366-1.366h9.196C320.5,132.581,321.111,133.192,321.111,133.947L321.111,133.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34313A"
    },
    d: "M305.219,133.947c0,0.755-0.612,1.366-1.366,1.366h-6.564c-0.754,0-1.366-0.612-1.366-1.366l0,0    c0-0.754,0.612-1.366,1.366-1.366h6.564C304.607,132.581,305.219,133.192,305.219,133.947L305.219,133.947z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#34313A"
    },
    cx: 300.38,
    cy: 139.313,
    r: 1.608
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#34313A"
    },
    cx: 314.143,
    cy: 139.313,
    r: 1.608
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA686"
    },
    d: "M338.003,144.502c0,2.041-1.655,3.696-3.696,3.696l0,0c-2.041,0-3.696-1.655-3.696-3.696v-7.642    c0-2.041,1.655-3.696,3.696-3.696l0,0c2.041,0,3.696,1.655,3.696,3.696V144.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5876A"
    },
    d: "M345.841,174.162c-1.508,4.775-6.511,13.292-11.175,13.292c-4.664,0-7.223-8.517-5.715-13.292    c1.508-4.775,6.511-8.646,11.175-8.646C344.79,165.516,347.349,169.387,345.841,174.162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E03B66"
    },
    d: "M337.664,130.895v-6.925c0-9.993-8.1-18.093-18.093-18.093h-5.333    c-8.238,0-18.093,6.933-18.093,18.093v6.925H337.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE547B"
    },
    d: "M330.324,130.895v-6.925c0-9.993-4.482-18.093-10.012-18.093h-2.951    c-5.529,0-10.012,8.1-10.012,18.093v6.925H330.324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27242D"
    },
    d: "M328.981,130.485c0,0.49-0.478,0.888-1.067,0.888h-47.681c-0.589,0-1.067-0.398-1.067-0.888l0,0    c0-0.49,0.478-0.888,1.067-0.888h47.681C328.503,129.597,328.981,129.995,328.981,130.485L328.981,130.485z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27242D"
    },
    d: "M308.078,115.94c-3.463,0-6.27,2.838-6.27,6.34c0,3.501,2.807,6.34,6.27,6.34     c3.463,0,6.27-2.838,6.27-6.34C314.348,118.779,311.541,115.94,308.078,115.94z M308.078,127.477c-2.839,0-5.14-2.327-5.14-5.197     c0-2.87,2.301-5.196,5.14-5.196s5.14,2.326,5.14,5.196C313.218,125.15,310.917,127.477,308.078,127.477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27242D"
    },
    d: "M308.078,126.645c-2.292,0-4.156-1.958-4.156-4.365c0-2.407,1.865-4.365,4.156-4.365     c2.292,0,4.156,1.958,4.156,4.365C312.234,124.687,310.37,126.645,308.078,126.645z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakePhoto);
export default __webpack_public_path__ + "static/media/takePhoto.193715ae8f38e7cabdccfef5378c35f7.svg";
export { ForwardRef as ReactComponent };